import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import WsImportConst from '../constants/wsImport.constants';
import ImgIconComp from './imgcomp';
import { saveWsImport } from '../utils/common';
import { RadioButComp, CheckBoxComp } from './inputs/fields.component';
import JiraIntegrationPopup from './okr/wizard/jiraIntegrationPopup';
import DropdownComp from './dropdown/dropdown';
import { ThemeProvider } from '@workboard/wobo-ui';
import { withTranslation } from 'react-i18next';


import { hot } from 'react-hot-loader/root';

/* Import from Window */

class WorkStreamImport extends React.Component {
  constructor(props) {
    super(props);
    this.selJira = this.selJira.bind(this);
    this.selGitHub = this.selGitHub.bind(this);
    this.getGitHubRepositories = this.getGitHubRepositories.bind(this);
    this.selAsana = this.selAsana.bind(this);
    this.tabActive = this.tabActive.bind(this);
    this.unmoundComp = this.unmoundComp.bind(this);
  }

  selJira() {
    // console.log(this.props.wsImport);
    // console.log(this.props.externalApps);
    // let isJiraLoggedIn  = true;
    const isJiraLoggedIn = this.props.wsImport.externalApps.jira || false;
    this.tabActive('import-from-jira');
    this.props.actions.ShowComp({ compName: '', action: 'hide' });
    this.props.actions.ImportFrom({ importFrom: 'jira' });
    if (!isJiraLoggedIn) {
      loadJiraIntegrationPopup('#wsImportLogin', undefined, (url, data) => {
        const instance = { belong_to: url, token_state: "valid" };
        this.props.actions.saveInstances([instance]);
        this.props.actions.ShowComp({ compName: 'selInstance', action: 'show' });
        this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'show' })
        this.props.actions.updateExternalApps('jira', true);
      })
      // if (document.getElementById('wsImportLogin')) {
      //   ReactDOM.unmountComponentAtNode(document.getElementById('wsImportLogin'));
      // }
      // ReactDOM.render(<JiraIntegrationPopup
      //   closePopup={() => ReactDOM.unmountComponentAtNode(document.getElementById('wsImportLogin'))}
      //   updateParentState={function() {
      //     this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'show' });
      //     this.props.actions.updateExternalApps('jira', true);
      //   }} />, document.getElementById('wsImportLogin'));
    } else {
      this.getJiraInstances();
    }
  }

  getJiraInstances() {
    this.props.actions.saveInstances([]);
    showLoaderWidget($('#content'));
    $.ajax({
      url: `${wbConfig.baseUrl}/integration/getAllInstances`,
      type: "GET",
      data: {
        app: "jira",
      }
    })
      .done(res => {
        removeLoader();
        if (res && res.data.length) {
          this.props.actions.saveInstances(res.data);
          this.props.actions.ShowComp({ compName: 'selInstance', action: 'show' });
          this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'show'});
        }
      })
  }

  selGitHub() {
    this.tabActive('import-from-github');
    this.props.actions.ShowComp({ compName: '', action: 'hide' });
    this.props.actions.ImportFrom({ importFrom: 'github' });
    const isGithubLoggedIn = this.props.wsImport.externalApps.github || false;
    if (!isGithubLoggedIn) {
      wsImportgitLogin.dialog('open');
      if (document.getElementById('wsImportgitLogin')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('wsImportgitLogin'));
      }
      ReactDOM.render(<LoginGitHub actions={this.props.actions} getGitHubRepositories={this.getGitHubRepositories} t={this.props.t} />, document.getElementById('wsImportgitLogin'));
    } else {
      this.getGitHubRepositories();
    }
  }

  getGitHubRepositories() {
    // console.log("getGitHubRepositories");
    const _this = this;
    this.props.actions.saveRepositoriesIds('empty', false);
    showLoaderWidget($('#content'));
    $.ajax({
      url: `${wbConfig.baseUrl}/integration/queryExtProjects`,
      type: 'get',
      data: { app: 'github', type: 'repositories' },
    })
      .done((response) => {
        // console.log(response)
        removeLoader();
        if (typeof response === 'string') {
          response = response.trim();
        }
        if (response == '' || response.length == 0) {
          // console.log("response if");
        } else {
          _this.props.actions.saveRepositories(response.data);
          if (response.error && response.error != '') {
            _this.props.actions.saveRepositoriesError(response.error);
          }
          _this.props.actions.ShowComp({ compName: 'selRepo', action: 'show' });
        }
      });
  }

  selAsana() {
    this.tabActive('import-from-asana');
    this.props.actions.ImportFrom({ importFrom: 'asana' });
    this.props.actions.ShowComp({ compName: '', action: 'hide' });
    const isAsanaLoggedIn = this.props.wsImport.externalApps.asana || false;
    if (!isAsanaLoggedIn) {
      wsImportgitLogin.dialog('open');
      if (document.getElementById('wsImportgitLogin')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('wsImportgitLogin'));
      }
      ReactDOM.render(<LoginAsana actions={this.props.actions} t={this.props.t} />, document.getElementById('wsImportgitLogin'));
    } else {
      this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'show' });
    }
  }

  tabActive(tab) {
    $('.from-tab').removeClass('active');
    $('.mapTo-tab').removeClass('active');
    $(`.${tab}`).addClass('active');
  }

  unmoundComp() {
    ReactDOM.unmountComponentAtNode(document.getElementById('ComponentMap'));
    ReactDOM.unmountComponentAtNode(document.getElementById('selRepo'));
    ReactDOM.unmountComponentAtNode(document.getElementById('selectImportProject'));
    ReactDOM.unmountComponentAtNode(document.getElementById('ownerMapping'));
  }

  render() {
    const { t } = this.props;
    const importFrom = this.props.wsImport.importFrom || '';
    const projectId = this.props.wsImport.projectIds || [];
    console.log(this.props);
    const showComp = this.props.wsImport.showComp || [];
    const instances = this.props.wsImport.instances || [];
    let jiraActive = '';
    let githubActive = '';
    let asanaActive = '';
    if (importFrom == 'jira') {
      jiraActive = 'active';
    } else if (importFrom == 'asana') {
      asanaActive = 'active';
    } else if (importFrom == 'github') {
      githubActive = 'active';
    }
    return (
      <div>
        <div className="wsImprotComp import-from">
          <div className="wsImportCompTitle import-from-title">{t("Where do you want to import from")}?</div>
          <div className="import-from-tabs">
            <div className={`from-tab import-from-jira ${jiraActive}`} onClick={e => this.selJira()}>
              <div className="from-tab-img">{<ImgIconComp id="jira" width="50" height="40" />}</div>
              <div className="from-tab-lable">{t("Jira")}</div>
            </div>
            <div className={`from-tab import-from-github ${githubActive}`} onClick={e => this.selGitHub()}>
              <div className="from-tab-img">{<ImgIconComp id="github" width="50" height="40" />}</div>
              <div className="from-tab-lable">{t("GitHub")}</div>
            </div>
            <div className={`from-tab import-from-asana ${asanaActive}`} onClick={e => this.selAsana()}>
              <div className="from-tab-img">{<ImgIconComp id="asana" width="50" height="40" />}</div>
              <div className="from-tab-lable">{t("Asana")}</div>
            </div>
          </div>
        </div>

        <div id="selRepo" className="selRepo">
          {showComp.indexOf('selRepo') > -1 && <SelRepo actions={this.props.actions} items={this.props.wsImport} t={this.props.t} />}
        </div>

        <div id="selInstance" className="selInstance">
          {showComp.indexOf('selInstance') > -1 && instances.length && <SelInstance actions={this.props.actions} items={this.props.wsImport} t={this.props.t} />}
        </div>

        <div id="ComponentMap" className="ComponentMap">
          {showComp.indexOf('ComponentMap') > -1 && <ComponentMap actions={this.props.actions} items={this.props.wsImport} t={this.props.t} />}
        </div>

        <div id="selectImportProject" className="selectImportProject">
          {showComp.indexOf('selectImportProject') > -1 && <SelectImportProject actions={this.props.actions} items={this.props.wsImport} t={this.props.t} />}
        </div>
        {projectId && projectId.length > 0
          && (
          <div id="ComponentMap" className="ComponentMap">
            {showComp.indexOf('ComponentMap') > -1 && importFrom == 'jira' && <ComponentMap actions={this.props.actions} items={this.props.wsImport} jiraBasic t={this.props.t} />}
          </div>
          )
        }
        <div id="ownerMapping" className="ownerMapping">
          {showComp.indexOf('ownerMapping') > -1 && <OwnerMapping actions={this.props.actions} items={this.props.wsImport} t={this.props.t} />}
        </div>
      </div>
    );
  }
}

/* JIRA invalid jql error Pop up */
class InvalidJql extends React.Component {
  constructor(props) {
    super(props);
    this.closeJiraPopup = this.closeJiraPopup.bind(this);
  }

  closeJiraPopup() {
    $(wsImportJqlError).dialog('close');
  }

  render() {
    const { t } = this.props;
    return (
      <div className="login-jira-wrap" style={{ padding: '10px' }}>
        <div className="login-popup-row" style={{ borderBottom: '1px solid lightgrey' }}>
          <div className="login-popup-col login-jira-title">
            {t("Error in Query")}
            <div
              className="closeGitPopup right clickable"
              style={{ margin: '0' }}
              onClick={e => this.closeJiraPopup()}
            >
              <ImgIconComp id="close" />
            </div>
          </div>
        </div>
        <div className="login-popup-row padding10">
          <div className="login-popup-col padding5">
          {t("There was an error in the query you have added. Please verify that it is a valid JQL query and try again")}.
          </div>
          <div
            className="gbl-btn right clickable"
            style={{
              width: '40px !important', height: '24px', padding: '10px', margin: '5px auto', textAlign: 'center',
            }}
            onClick={e => this.closeJiraPopup()}
          >
{t("Ok")}
          </div>
        </div>
      </div>
    );
  }
}

/** Show Jira JQL validation results in popup
 * @private
 * @function ValidateJiraJqlResults
 * @param {string} jqlVal value of the jql to be validated
 * @author [Snehal Shah](https://github.com/woshah)
*/
class ValidateJiraJqlResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jiraJql: this.props.jiraJql || '',
      resultArr: this.props.resultArr || [],
      resultsCount: this.props.resultsCount || 0,
    };
    this.reValidateJira = this.reValidateJira.bind(this);
    this.closeJiraPopup = this.closeJiraPopup.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  /**
 * @function reValidateJira
 * @description Used to revalidate whether the new entered value of the jql is right or not.
 */
  reValidateJira() {
    const _this = this;
    const data = new FormData();
    const complete_query = this.state.jiraJql;
    if (complete_query.length == 0) {
      return;
    }
    data.append('qcomplete', complete_query);
    data.append('qincomplete', '');
    data.append('progress', '');
    data.append('instance_url', this.props.items.selectedInstance.belong_to)
    showLoaderWidget($('#content'));
    $.ajax({
      url: '/wb/integration/queryExtProjects?app=jira',
      data,
      cache: false,
      contentType: false,
      processData: false,
      method: 'POST',
    })
      .done((data) => {
        removeLoader();
        if (data.data.status === 'error') {
          alert('There was an error with the jql. Please try again.');
        } else {
          const validationResults = data.data.resultList || [];
          _this.setState({
            resultArr: validationResults,
            resultsCount: data.data.totalCount || 0,
          });
        }
      });
  }

  closeJiraPopup() {
    this.props.updateJql(this.state.jiraJql);
    $(wsImportJiraValidationResults).dialog('close');
  }

  handleTextChange(e) {
    this.setState({
      jiraJql: e.target.value,
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="login-jira-wrap" style={{ padding: '10px' }}>
        <div className="login-popup-row" style={{ borderBottom: '1px solid lightgrey' }}>
          <div className="login-popup-col login-jira-title">
            <div
              className="closeGitPopup right clickable"
              style={{ margin: '0' }}
              onClick={e => this.closeJiraPopup()}
            >
              <ImgIconComp id="close" />
            </div>
            <h3 style={{ margin: '5px' }}>{t("JIRA Issues")}</h3>
          </div>
        </div>
        <div className="login-popup-row padding10">
          <h5>
            <ImgIconComp id="jira" width={24} />
            {' '}
            {t("JIRA JQL query for all issues to be imported")}:
          </h5>
          <textarea
            value={this.state.jiraJql}
            onChange={this.handleTextChange.bind(this)}
            style={{
              width: '85%', 'border-radius': '5px', 'min-height': '75px', resize: 'none', padding: '5px', display: 'inline-block', margin: '0px 15px',
            }}
          />
          <img
            src={`${wbConfig.baseUrl}/images/workstreams/reload_button@3x.png`}
            id="reload_button"
            onClick={this.reValidateJira.bind(this)}
            width={32}
            style={{ display: 'inline-block', verticalAlign: 'bottom' }}
          />
        </div>
        <div className="login-popup-row padding10">
          <h3>
          {t("Search Results")} (
            {this.state.resultsCount}
            {' '}
            {t("matches")})
          </h3>
          <div className="login-popup-col validation-table padding5" style={{ borderBottom: '1px solid lightgrey', padding: '0 25px' }}>
            {this.state.resultArr.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>{t("Key")}</th>
                  <th>{t("Summary")}</th>
                  <th style={{ paddingLeft: '15px' }}>{t("Status")}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.resultArr.map((item, index) => (
                  <tr key={index} style={{ margin: '10px 5px' }}>
                    <td style={{
                      width: '15%', paddingBottom: '10px', marginRight: '10px', verticalAlign: 'text-top',
                    }}
                    >
                      {item.key}
                    </td>
                    <td style={{ width: '65%', paddingBottom: '10px', verticalAlign: 'text-top' }}>{item.fields.summary}</td>
                    <td style={{
                      width: '15%', paddingBottom: '10px', paddingLeft: '15px', verticalAlign: 'text-top',
                    }}
                    >
                      {item.fields.status.name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            )}
            {this.state.resultArr.length == 0 && <h3 style={{ textAlign: 'center' }}>No issues were found to match your search. Try modifying your JQL query and reloading.</h3>}
          </div>
          <div
            className="gbl-btn right clickable"
            style={{
              width: '40px !important', height: '24px', padding: '10px', margin: '5px auto', textAlign: 'center',
            }}
            onClick={e => this.closeJiraPopup()}
          >
{t("Save")}
          </div>
        </div>
      </div>
    );
  }
}

/* login GitHub popup */
class LoginGitHub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showGitHubHelp: false,
      login_error: false,
      accessToken: null,
    };
    this.closeGitPopup = this.closeGitPopup.bind(this);
    this.loginGitHubAuth = this.loginGitHubAuth.bind(this);
    this.showGitHubHelp = this.showGitHubHelp.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  closeGitPopup() {
    $(wsImportgitLogin).dialog('close');
  }

  loginGitHubAuth() {
    const _this = this;
    const accessToken = $(_this.refs.gitHub_token).val().trim();
    const githubHostName = $(_this.refs.gitHub_hostname).val().trim();
    // console.log(githubHostName);
    if (accessToken.length > 0) {
      _this.setState({
        accessToken,
      });
      showLoaderWidget($('#content'));
      $.ajax({
        url: `${wbConfig.baseUrl}/integration/hello`,
        type: 'POST',
        data: {
          app: 'github', access_token: accessToken, githubHostName, scope: 'token',
        },
      })
        .done((response) => {
          removeLoader();
          if (typeof response === 'string') {
            response = response.trim();
          }
          if (response == '' || response.length == 0) {
            _this.setState({
              login_error: true,
              accessToken: '',
            });
          } else {
            $(wsImportgitLogin).dialog('close');
            _this.props.actions.updateExternalApps('github', true);
            _this.props.getGitHubRepositories();
          }
        });
    } else {
      _this.setState({
        login_error: true,
      });
    }
  }

  showGitHubHelp() {
    this.setState({
      showGitHubHelp: true,
    });
  }

  handleChange() {
    this.setState({
      login_error: false,
    });
  }

  render() {
    const { t } = this.props;
    const { login_error } = this.state;
    return (
      <div className="login-git-wrap">
        <div className="login-git-logo">
          <img className="" width="175px" src={`${wbConfig.baseUrl}/images/icons/integration/login_git.png`} />
          <div className="closeGitPopup right clickable" onClick={e => this.closeGitPopup()}>
            <ImgIconComp id="close" />
          </div>
        </div>
        <div className="login-git-auth">
          <div>
            <div>
              {t("Allow Workboard to access your GitHub account")}.
            </div>
            <div className="pT10">
              {t("Personal Access Token (required)")}
            </div>
            <div className="pT10">
              {t("Please follow the steps")}
              {' '}
              <span className="clickHere" onClick={this.showGitHubHelp}>here</span>
              {' '}
              {t("to get GitHub's personal access token")}.
            </div>
            {
              this.state.showGitHubHelp
              && (
              <div className="pT10 pB10">
                <div>
                  1- {t("Login to your account")}
                </div>
                <div>
                  2- {t("Click on your profile photo")}
                </div>
                <div>
                  3- {t("Click on Settings")}
                </div>
                <div>
                  4- {t("Click on Developer settings")}
                </div>
                <div>
                  5- {t("Click on Personal access tokens")}
                </div>
                <div>
                  6- {t("Under PERSONAL ACCESS TOKENS, click on Generate new token")}
                </div>
                <div>
                  7- {t("Put any description that you would remember, select scopes and click on Generate token button")}
                </div>
                <div>
                  8- {t("Copy the token and go back to your Workboard's import workstream window, paste the token")}
                </div>
              </div>
              )
            }
            <div>
            {t("Paste the token in the field mentioned below")}.
            </div>
          </div>
          <div className="padding10">
            <input placeholder="Personal access token" ref="gitHub_token" className="git-login-text-input" type="text" name="access_token" onChange={e => this.handleChange(e)} />
          </div>

          <div className="padding10">
            <div>
            {t("If you are using an enterprise version instance of Git, enter the URL here")}
            </div>
            <input placeholder="Enterprise URL" ref="gitHub_hostname" className="git-login-text-input" type="text" name="github_hostname" />
          </div>
          <div className="padding10">
            <input type="button" className="git-login-btn login-btn" value="Yes, Continue" onClick={e => this.loginGitHubAuth()} />
            {
              login_error
              && <p className="login-error-msg login-error-msg-show">{t("Authorization failed: check your GitHub Personal Access Token")}</p>
            }
          </div>
        </div>
      </div>
    );
  }
}

/* Login Asana popup */
class LoginAsana extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: '',
      login_error: false,
    };
    this.closeAssanaPopup = this.closeAssanaPopup.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.loginAsana = this.loginAsana.bind(this);
    this.asanaHelpPopup = this.asanaHelpPopup.bind(this);
  }

  closeAssanaPopup() {
    $(wsImportgitLogin).dialog('close');
  }

  getAccessToken(e) {
    const _this = this;
    const accessToken = e.target.value;
    setTimeout(() => _this.setState({
      accessToken,
      login_error: false,
    }),
    10);
  }

  loginAsana() {
    const _this = this;
    const { accessToken } = _this.state;
    if (!accessToken) {
      _this.setState({
        login_error: true,
      });
    } else {
      showLoaderWidget($('#content'));
      $.ajax({
        url: `${wbConfig.baseUrl}/integration/hello`,
        type: 'POST',
        data: { app: 'asana', access_token: accessToken, scope: 'token' },
      })
        .done((response) => {
          removeLoader();
          if (typeof response === 'string') {
            response = response.trim();
          }
          if (response == '' || response.length == 0) {
            _this.setState({
              login_error: true,
              accessToken: '',
              // 0/a578d3f7ba291cf2512e2763bd0c5cb6
            });
          } else {
            _this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'show' });
            _this.props.actions.updateExternalApps('asana', true);
            $(wsImportgitLogin).dialog('close');
          }
        });
    }
  }

  asanaHelpPopup() {
    ReactDOM.render(<AsanaHelp t={this.props.t} />, document.getElementById('asanHelpPopup'));
  }

  render() {
    const { t } = this.props;
    const { accessToken } = this.state;
    const { login_error } = this.state;
    // console.log(login_error+"login_error");
    return (
      <div className="ws-import-login-assana">
        <div>
          <img className="" width="175px" src={`${wbConfig.baseUrl}/images/icons/integration/assana.png`} />
          <div className="closeGitPopup right clickable" onClick={e => this.closeAssanaPopup()}>
            <ImgIconComp id="close" />
          </div>
        </div>

        <div className="login-popup-row">
          <div className="login-popup-col padding10 lable">
          {t("Allow Workboard to access your Asana's account")}
          </div>
        </div>
        <div id="asanHelpPopup" />
        <div className="login-popup-row">
          <div className="login-popup-col">
            <div className="login-input-label padding10">
              <span className="label-head">{t("Personal Access Token")}</span>
              {' '}
              <span className="required">({t("required")})</span>
            </div>
            <div className="login-input-label asana-access-token padding10">
              {t("Please follow the steps")}
              {' '}
              <span className="clickHere" onClick={e => this.asanaHelpPopup()}>here</span>
              {' '}
              {t("to get a Asana's personal access token. Paste the token in the field mentioned below")}.
            </div>
            <div className="padding10">
              <input placeholder="password" className="login-text-input" autocomplete="off" type="password" name="asana_personal_token" id="asana_personal_token" onChange={e => this.getAccessToken(e)} value={accessToken} />
            </div>
          </div>
        </div>
        <div className="login-popup-row">
          <div className="login-popup-col padding10">
            <input type="button" className="login-btn" value="Yes, Continue" onClick={e => this.loginAsana()} />
            {
              login_error
              && <p className="login-error-msg login-error-msg-show">{t("Authorization failed- check your Asana public access token")}</p>
            }
          </div>
        </div>
      </div>
    );
  }
}

/* Asana Help popup */
class AsanaHelp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: '',
      login_error: false,
    };
    this.closeHelpPopup = this.closeHelpPopup.bind(this);
  }

  closeHelpPopup() {
    ReactDOM.unmountComponentAtNode(document.getElementById('asanHelpPopup'));
  }

  render() {
    const { t } = this.props;
    return (
      <div className="asanaHelpPopup">
        <div className="closeGitPopup right clickable" onClick={e => this.closeHelpPopup()}>
          <ImgIconComp id="close" />
        </div>
        <div className="helpWrap">
          <div>
            1- {t("Click  and login to your account")}
            <br />
            2- {t("Click on your profile photo")}
            <br />
            3- {t("Click on My Profile Setting")}
            <br />
            4- {t("Click on Apps tab")}
            <br />
            5- {t("Click on Manage Developer Apps")}
            <br />
            6- {t("Under PERSONAL ACCESS TOKENS, click on  Create New Personal Access Token")}
            <br />
            7- {t("Put any description that you would remember and click on Create button")}
            <br />
            8- {t("Copy the token and go back to your Workboard's import workstream window, paste the token")}
          </div>
        </div>
      </div>
    );
  }
}

class ComponentMap extends React.Component {
  constructor(props) {
    super(props);
    const importEditData = this.props.items.importEditData || {};
    let selectedOption = 'basic';
    let jqlVal = '';
    const importId = this.props.items.importId || 0;
    if (importId != 0 && importEditData.projectType == 'jql') {
      selectedOption = 'jql';
      jqlVal = importEditData.import_jql;
    }
    this.state = {
      selectedOption,
      showCompleteJqlError: false,
      jqlVal,
      jqlIsVerified: false
    };
    this.storyClick = this.storyClick.bind(this);
    this.listProject = this.listProject.bind(this);
    this.epicClick = this.epicClick.bind(this);
    this.projectClick = this.projectClick.bind(this);
    this.tabActive = this.tabActive.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.validateJqlQuery = this.validateJqlQuery.bind(this);
    this.updateJql = this.updateJql.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.saveActionItemJql = this.saveActionItemJql.bind(this);
    this.syncTaskClicked = this.syncTaskClicked.bind(this);
    this.handleWorkStreamNameChange = this.handleWorkStreamNameChange.bind(this);
    this.getJiraBasicMapping = this.getJiraBasicMapping.bind(this);
  }

  componentDidMount() {
    if (this.props.items.importFrom == 'jira') {
      this.getJiraBasicMapping();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.items.selectedInstance && this.props.items.selectedInstance.belong_to !== prevProps.items.selectedInstance.belong_to) {
      this.setState({
        jqlIsVerified: false,
        showCompleteJqlError: false
      })
      this.props.actions.ShowComp({ compName: 'selectImportProject', action: 'hide' });
      this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
      this.props.actions.saveProjectIds('empty', false, '', this.props.items.importFrom);
      this.props.actions.SetPorjectData([], null);
      this.props.actions.saveSyncTask(false);
      $('.mapTo-tab').removeClass('active');
    }
  }

  storyClick(name) {
    this.tabActive('story-tab');
    this.listProject(name);
    this.props.actions.setIsJql(false);
  }

  listProject(type) {
    const _this = this;
    this.props.actions.setIsJql(false);
    this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
    showLoaderWidget($('#content'));
    const { importFrom } = this.props.items;
    const { repositorieIds } = this.props.items;
    // console.log(this.props);
    this.props.actions.saveProjectIds('empty', false, '', importFrom);
    this.props.actions.saveSyncTask(false);
    $.ajax({
      url: `${wbConfig.baseUrl}/integration/queryExtProjects`,
      type: 'get',
      data: { app: importFrom, type, repositorieIds,
        instance_url: importFrom === "jira" ? this.props.items.selectedInstance.belong_to : "" },
    })
      .done((response) => {
        removeLoader();
        if (typeof response === 'string') {
          response = response.trim();
        }
        if (response == '' || response.length == 0) {
          // #TODO (ADITHYA): PLEASE CHECK WHAT NEEDS TO BE DONE IF RESPONSE IS EMPTY
        } else {
          _this.props.actions.SetPorjectData(response.data, type);
          if (response.error && response.error != '') {
            _this.props.actions.saveRepositoriesError(response.error);
          }
          setTimeout(() => {
            _this.props.actions.ShowComp({ compName: 'selectImportProject', action: 'show' });
          }, 10);
        }
      });
  }

  epicClick(epicName) {
    this.tabActive('epic-tab');
    this.listProject(epicName);
    this.props.actions.setIsJql(false);
  }

  projectClick(project) {
    this.tabActive('project-tab');
    this.listProject(project);
    this.props.actions.setIsJql(false);
  }

  tabActive(tab) {
    $('.mapTo-tab').removeClass('active');
    $(`.${tab}`).addClass('active');
  }

  handleOptionChange(e) {
    this.setState({
      selectedOption: e.target.value,
    });
    this.props.actions.ShowComp({ compName: 'selectImportProject', action: 'hide' });
    // console.log('this.props.items.importFrom', this.props.items.importFrom);
    this.props.actions.SwitchBasicJql(this.props.items.importFrom);
  }

  validateJqlQuery() {
    const _this = this;
    const data = new FormData();
    this.props.items.syncTask = false;
    const complete_query = this.state.jqlVal || '';
    if (complete_query.length == 0) {
      return this.setState({ showCompleteJqlError: true });
    }
    data.append('qcomplete', complete_query);
    data.append('qincomplete', '');
    data.append('progress', '');
    data.append('instance_url', this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "");
    this.props.actions.setIsJql(true);
    this.props.items.jql = complete_query;
    showLoaderWidget($('#content'));
    $.ajax({
      url: `${wbConfig.baseUrl}/integration/queryExtProjects?app=jira`,
      data,
      cache: false,
      contentType: false,
      processData: false,
      method: 'POST',
    })
      .done((data) => {
        removeLoader();
        if (data.data.status === 'error') {
          wsImportJqlError.dialog('open');
          if (document.getElementById('wsImportJqlError')) {
            ReactDOM.unmountComponentAtNode(document.getElementById('wsImportJqlError'));
          }
          ReactDOM.render(<InvalidJql t={_this.props.t} />, document.getElementById('wsImportJqlError'));
        } else {
          const validationResults = data.data.resultList || [];
          const resultsCount = data.data.totalCount || 0;
          wsImportJiraValidationResults.dialog('open');
          if (document.getElementById('wsImportJiraValidationResults')) {
            ReactDOM.unmountComponentAtNode(document.getElementById('wsImportJiraValidationResults'));
          }
          let followers = [];
          showLoaderWidget($('#content'));
          const url = `${wbConfig.baseUrl}/integration/getImportDataDetails`;
          $.post(url, { app: 'jira' }, (resp) => {
            // CORE-13020: guard against null resp.data.data; older flows sometimes
            // return {data: {data: null}} and the unguarded `.followers` access
            // would throw and abort the setTimeout before removeLoader() ran.
            followers = (resp && resp.data && resp.data.data && resp.data.data.followers) || [];
            setTimeout(() => {
              _this.setState({ showCompleteJqlError: false });
              ReactDOM.render(<ValidateJiraJqlResults
                resultArr={validationResults}
                resultsCount={resultsCount}
                jiraJql={_this.state.jqlVal}
                updateJql={_this.updateJql}
                items={_this.props.items}
                t={_this.props.t}
              />,
              document.getElementById('wsImportJiraValidationResults'));
              _this.props.items.itemToBeImport.followers = followers;
              this.props.actions.setIsJql(true);
              // _this.props.actions.ShowComp({compName:"ownerMapping",action: "show"});
              removeLoader();
            }, 10);
          });
        }
      });
  }

  getJiraBasicMapping() {
    showLoaderWidget($('#content'));
    axios.get(`${wbConfig.baseUrl}/integration/queryExtFields?app=jira&include=resolution`).then((resp) => {
      const mapVals = [];
      const resMapVals = [];
      const defaultMapVals = {};
      const savedMapValsdoing = {};
      const savedMapValsdone = {};
      const savedMapValsnext = {};
      const savedMapValspause = {};
      // console.log('this.props.items', this.props.items);
      if (this.props.items.importEditData && this.props.items.importEditData.import_status_mapping.length > 0) {
        console.log('IN SIDE IF getJiraBasicMapping', this.props.items);
        const exitData = this.props.items.importEditData.import_status_mapping;
        exitData.map((val) => {
          if (val.wb_status == '0') {
            savedMapValsdone[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
          } else if (val.wb_status == '1') {
            savedMapValsdoing[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
          } else if (val.wb_status == '2') {
            savedMapValsnext[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
          } else if (val.wb_status == '4') {
            savedMapValspause[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
          }
        });
        console.log('savedMapValsdoing', savedMapValsdoing);
        console.log('savedMapValsdone', savedMapValsdone);
        console.log('savedMapValsnext', savedMapValsnext);
        console.log('savedMapValspause', savedMapValspause);
      }
      resp.data.data.fields.status.map((val, index) => {
        mapVals.push({ id: `${val.id}*status`, text: val.name });
        defaultMapVals[val.name.split(' ').join('_').toLowerCase()] = `${val.id}*status`;
      });
      console.log('mapVals', mapVals);
      resp.data.data.fields.resolution.map((val, index) => {
        resMapVals.push({ id: `${val.id}*resolution`, text: val.name });
      });
      console.log('resMapVals', resMapVals);
      removeLoader();
      $('.jira-workflow-select-doing').select2({
        placeholder: 'Custom Workflow Selection',
        allowClear: true,
        data: [
          {
            text: 'STATUS',
            children: mapVals,
          },
          {
            text: 'RESOLUTION',
            children: resMapVals,
          },
        ],
      });
      $('.jira-workflow-select-done').select2({
        placeholder: 'Custom Workflow Selection',
        allowClear: true,
        data: [
          {
            text: 'STATUS',
            children: mapVals,
          },
          {
            text: 'RESOLUTION',
            children: resMapVals,
          },
        ],
      });
      $('.jira-workflow-select-next').select2({
        placeholder: 'Custom Workflow Selection',
        allowClear: true,
        data: [
          {
            text: 'STATUS',
            children: mapVals,
          },
          {
            text: 'RESOLUTION',
            children: resMapVals,
          },
        ],
      });
      $('.jira-workflow-select-pause').select2({
        placeholder: 'Custom Workflow Selection',
        allowClear: true,
        data: [
          {
            text: 'STATUS',
            children: mapVals,
          },
          {
            text: 'RESOLUTION',
            children: resMapVals,
          },
        ],
      });
      // Selecting the defaults

      if (this.props.items.importEditData && this.props.items.importEditData.import_status_mapping.length > 0) {
        console.log('...Object.values(savedMapValsdoing)', Object.values(savedMapValsdoing));
        $('.jira-workflow-select-doing').val(Object.values(savedMapValsdoing));
        $('.jira-workflow-select-done').val(Object.values(savedMapValsdone));
        $('.jira-workflow-select-next').val(Object.values(savedMapValsnext));
        $('.jira-workflow-select-pause').val(Object.values(savedMapValspause));
      } else {
        $('.jira-workflow-select-doing').val([defaultMapVals.to_do, defaultMapVals.in_progress]);
        $('.jira-workflow-select-done').val([defaultMapVals.done, defaultMapVals.invalid, defaultMapVals.declined, defaultMapVals["can't_reproduce"], defaultMapVals.fixed]);
        $('.jira-workflow-select-next').val([defaultMapVals.selected_for_development, defaultMapVals.next]);
        $('.jira-workflow-select-pause').val([defaultMapVals.backlog, defaultMapVals["won't_fix"]]);
      }
      // Notify any JS components that the value changed
      $('.jira-workflow-select-doing').trigger('change');
      $('.jira-workflow-select-done').trigger('change');
      $('.jira-workflow-select-next').trigger('change');
      $('jira-workflow-select-pause').trigger('change');
    }).catch((err) => {
      console.log('ERROR IN CATCH', err);
      toastr.error('We\'re sorry but we could not process this request. If this issue persists, please contact support@workboard.com');
    });
  }

  updateJql(val) {
    const _this = this;
    showLoaderWidget($('#content'));
    axios.get(`${wbConfig.baseUrl}/integration/queryExtFields?app=jira&include=resolution`).then((resp) => {
      _this.props.items.jql = val;
      _this.setState({
        jqlVal: val,
        jqlIsVerified: true,
      }, () => {
        const mapVals = [];
        const resMapVals = [];
        const defaultMapVals = {};
        const savedMapValsdoing = {};
        const savedMapValsdone = {};
        const savedMapValsnext = {};
        const savedMapValspause = {};
        if (this.props.items.importEditData && this.props.items.importEditData.import_status_mapping.length > 0) {
          const exitData = this.props.items.importEditData.import_status_mapping;
          exitData.map((val) => {
            if (val.wb_status == '0') {
              savedMapValsdone[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
            } else if (val.wb_status == '1') {
              savedMapValsdoing[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
            } else if (val.wb_status == '2') {
              savedMapValsnext[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
            } else if (val.wb_status == '4') {
              savedMapValspause[val.ext_status.split(' ').join('_').toLowerCase()] = `${val.type_id}*${val.type}`;
            }
          });
        }
        resp.data.data.fields.status.map((val) => {
          mapVals.push({ id: `${val.id}*status`, text: val.name });
          defaultMapVals[val.name.split(' ').join('_').toLowerCase()] = `${val.id}*status`;
        });
        resp.data.data.fields.resolution.map((val) => {
          resMapVals.push({ id: `${val.id}*resolution`, text: val.name });
        });
        removeLoader();
        $('.jira-workflow-select-doing').select2({
          placeholder: 'Custom Workflow Selection',
          allowClear: true,
          data: [
            {
              text: 'STATUS',
              children: mapVals,
            },
            {
              text: 'RESOLUTION',
              children: resMapVals,
            },
          ],
        });
        $('.jira-workflow-select-done').select2({
          placeholder: 'Custom Workflow Selection',
          allowClear: true,
          data: [
            {
              text: 'STATUS',
              children: mapVals,
            },
            {
              text: 'RESOLUTION',
              children: resMapVals,
            },
          ],
        });
        $('.jira-workflow-select-next').select2({
          placeholder: 'Custom Workflow Selection',
          allowClear: true,
          data: [
            {
              text: 'STATUS',
              children: mapVals,
            },
            {
              text: 'RESOLUTION',
              children: resMapVals,
            },
          ],
        });
        $('.jira-workflow-select-pause').select2({
          placeholder: 'Custom Workflow Selection',
          allowClear: true,
          data: [
            {
              text: 'STATUS',
              children: mapVals,
            },
            {
              text: 'RESOLUTION',
              children: resMapVals,
            },
          ],
        });
        // Selecting the defaults
        // console.log('this.props.items', this.props.items);
        if (this.props.items.importEditData && this.props.items.importEditData.import_status_mapping.length > 0) {
          $('.jira-workflow-select-doing').val(...Object.values(savedMapValsdoing));
          $('.jira-workflow-select-done').val(...Object.values(savedMapValsdone));
          $('.jira-workflow-select-next').val(...Object.values(savedMapValsnext));
          $('.jira-workflow-select-pause').val(...Object.values(savedMapValspause));
        } else {
          $('.jira-workflow-select-doing').val([defaultMapVals.to_do, defaultMapVals.in_progress]);
          $('.jira-workflow-select-done').val([defaultMapVals.done, defaultMapVals.invalid, defaultMapVals.declined, defaultMapVals["can't_reproduce"], defaultMapVals.fixed]);
          $('.jira-workflow-select-next').val([defaultMapVals.selected_for_development, defaultMapVals.next]);
          $('.jira-workflow-select-pause').val([defaultMapVals.backlog, defaultMapVals["won't_fix"]]);
        }

        // Notify any JS components that the value changed
        $('.jira-workflow-select-doing').trigger('change');
        $('.jira-workflow-select-done').trigger('change');
        $('.jira-workflow-select-next').trigger('change');
        $('jira-workflow-select-pause').trigger('change');
      });
    }).catch((err) => {
      console.log('ERROR IN CATCH', err);
      toastr.error('We\'re sorry but we could not process this request. If this issue persists, please contact support@workboard.com');
    });
  }

  handleTextChange(e) {
    this.setState({
      jqlVal: e.target.value,
    });
  }

  saveActionItemJql() {
    // console.log('saveActionItemJql', this.props.items.wsName, this.props.items.importEditData)
    if ((typeof this.props.items.wsName === 'undefined' || this.props.items.wsName == '')
    && (typeof this.props.items.importEditData === 'undefined' || typeof this.props.items.importEditData.wsName === 'undefined'
      || this.props.items.importEditData.wsName == '')) {
      // console.log('GOING TO IF');
      return toastr.error('Please add a Workstream name');
    }
    const ws = (this.props.items.wsName && this.props.items.wsName.length > 0) ? this.props.items.wsName : this.props.items.importEditData.wsName;
    const saveItems = this.props.items.itemToBeImport;
    // console.log(saveItems.followers);
    const statusMap = {
      done: { id: 0, values: [] },
      doing: { id: 1, values: [] },
      next: { id: 2, values: [] },
      pause: { id: 4, values: [] },
    };
    const doneArr = $('.jira-workflow-select-done').select2('data');
    doneArr.map((item, index) => {
      statusMap.done.values.push({
        id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1],
      });
    });
    const doingArr = $('.jira-workflow-select-doing').select2('data');
    doingArr.map((item, index) => {
      statusMap.doing.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const nextArr = $('.jira-workflow-select-next').select2('data');
    nextArr.map((item, index) => {
      statusMap.next.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const pauseArr = $('.jira-workflow-select-pause').select2('data');
    pauseArr.map((item, index) => {
      statusMap.pause.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const ownerMap = saveItems.followers || [];
    const selectedInstance = this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "";
    saveWsImport(this.props.items.importFrom, null, ws, null, this.props.items.teamId, this.props.items.syncTask, ownerMap, null, null, this.props.items.importId, this.props.items.jql, statusMap, selectedInstance);
  }

  saveImportBasic() {
    // console.log('saveImportBasic', this.props.items.wsName, this.props.items.importEditData);
    if ((typeof this.props.items.wsName === 'undefined' || this.props.items.wsName == '')
    && (typeof this.props.items.importEditData === 'undefined' || typeof this.props.items.importEditData.wsName === 'undefined'
      || this.props.items.importEditData.wsName == '')) {
      // console.log('GOING TO IF');
      return toastr.error('Please add a Workstream name');
    }
    const ws = (this.props.items.wsName && this.props.items.wsName.length > 0) ? this.props.items.wsName : this.props.items.importEditData.wsName;
    const saveItems = this.props.items.itemToBeImport;
    // console.log(saveItems.followers);
    const statusMap = {
      done: { id: 0, values: [] },
      doing: { id: 1, values: [] },
      next: { id: 2, values: [] },
      pause: { id: 4, values: [] },
    };
    const doneArr = $('.jira-workflow-select-done').select2('data');
    doneArr.map((item, index) => {
      console.log('doneArr', item);
      statusMap.done.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const doingArr = $('.jira-workflow-select-doing').select2('data');
    doingArr.map((item, index) => {
      console.log('doingArr', item);
      statusMap.doing.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const nextArr = $('.jira-workflow-select-next').select2('data');
    nextArr.map((item, index) => {
      console.log('nextArr', item);
      statusMap.next.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const pauseArr = $('.jira-workflow-select-pause').select2('data');
    pauseArr.map((item, index) => {
      console.log('pauseArr', item);
      statusMap.pause.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const ownerMap = saveItems.followers || [];


    const { importFrom } = this.props.items;
    const projectType = this.props.items.projectType || '';
    let projectId = this.props.items.projectIds || [];
    projectId = projectId.join();

    const { teamId } = this.props.items;
    const repositoriesId = this.props.items.repositorieId;
    const repositoriesIds = this.props.items.repositorieIds;
    const oldPojectID = projectId;
    const importId = this.props.items.importId || 0;
    const selectedInstance = this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "";

    projectId = oldPojectID;

    // console.log('IN BASIC SAVE', statusMap);
    saveWsImport(importFrom, projectType, ws, projectId, teamId, this.props.items.syncTask, ownerMap, repositoriesId, repositoriesIds, importId, '', statusMap, selectedInstance, true);
  }

  syncTaskClicked(e, basic = false) {
    // console.log('SYNC TASK CLICKED');
    // return false
    const _this = this;
    if (!e.target.checked) {
      this.props.items.syncTask = false;
      this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
    } else {
      this.props.items.syncTask = true;
      this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'show' });
      removeLoader();
    }
    this.props.actions.setWsName(this.refs['ws-jql-wsName'].value || '');
  }

  handleWorkStreamNameChange(e) {
    this.props.actions.setWsName(e.target.value);
  }

  render() {
    const { t } = this.props;
    console.log('CHECKED FOR SYCN', this.props.items.syncTask);
    const { importFrom } = this.props.items;
    let StroyName = (importFrom == 'asana') ? 'Sections' : 'Story';
    StroyName = (importFrom == 'github') ? 'Project' : StroyName;
    const epicName = (importFrom == 'github') ? 'Label' : 'Epic';
    const projectName = (importFrom == 'github') ? 'Milestones' : 'Project';
    const importId = this.props.items.importId || 0;
    let storyActive = '';
    let epicActive = '';
    let projectActive = '';
    const projectIds = this.props.items.projectIds || [];
    if (importId != 0) {
      const importEditData = this.props.items.importEditData || {};
      if (importEditData.projectType) {
        const { projectType } = importEditData;
        if (importEditData.importFrom == 'jira') {
          if (projectType == 'project') {
            projectActive = 'active';
          } else if (projectType == 'story') {
            storyActive = 'active';
          } else if (projectType == 'epic') {
            epicActive = 'active';
          }
        } else if (importEditData.importFrom == 'asana') {
          if (projectType == 'project') {
            projectActive = 'active';
          } else if (projectType == 'sections') {
            storyActive = 'active';
          }
        } else if (importEditData.importFrom == 'github') {
          if (projectType == 'project') {
            storyActive = 'active';
          } else if (projectType == 'label') {
            epicActive = 'active';
          } else if (projectType == 'milestones') {
            projectActive = 'active';
          }
        }
      }
    }
    if (importFrom == 'jira') {
      if (this.props.jiraBasic && this.props.jiraBasic == true && this.props.items.importFrom == 'jira' && projectIds.length > 0) {
        return (
          <div>
            <div className="wsImprotComp componentValidateForm">
              <div className="wsImportCompTitle">{t("Workflow Mapping to WorkBoard")}</div>
              <div style={{
                width: '45%', margin: 15, display: 'inline-block', 'text-align': 'left', marginTop: 10,
              }}
              >
                <div>
                  <div className="project-to-icon"><ImgIconComp id="jira" width="20" height="20" /></div>
                  <strong className="project-to-lable">{t("JIRA WORKFLOW")}</strong>
                </div>
                <div className="" style={{ marginTop: 15 }}>
                  <div>
                    <select style={{ width: '250px' }} multiple="multiple" className="jira-workflow-select-doing" />
                  </div>
                  <br />
                  <div>
                    <select style={{ width: '250px', marginTop: '10px' }} multiple="multiple" className="jira-workflow-select-done" />
                  </div>
                  <br />
                  <div>
                    <select style={{ width: '250px', marginTop: '10px' }} multiple="multiple" className="jira-workflow-select-next" />
                  </div>
                  <br />
                  <div>
                    <select style={{ width: '250px', marginTop: '10px' }} multiple="multiple" className="jira-workflow-select-pause" />
                  </div>
                  <br />
                </div>
              </div>
              <div style={{
                width: '45%', margin: 15, display: 'inline-block', verticalAlign: 'top', textAlign: 'left', marginTop: 10,
              }}
              >
                <div>
                  <div className="project-to-icon"><ImgIconComp id="workboard" width="20" height="20" /></div>
                  <strong className="project-to-lable">{t("WORKBOARD STATUS")}</strong>
                </div>
                <div className="" style={{ marginTop: 15 }}>
                  <p>
                    <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                    {t("DOING")}
                  </p>
                  <br />
                  <p>
                    <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                    {t("DONE")}
                  </p>
                  <br />
                  <p>
                    <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                    {t("NEXT")}
                  </p>
                  <br />
                  <p>
                    <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                    {t("PAUSE")}
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="wsImprotComp componentValidateForm">
              <div className="wsImportCompTitle">{t("Set up your WorkBoard Workstream")}</div>
              <div style={{
                width: '100%', padding: 15, 'text-align': 'left', marginTop: 10,
              }}
              >
                <div>
                  <div className="project-to-icon"><ImgIconComp id="workboard" width="20" height="20" /></div>
                  <strong className="project-to-lable">{t("Workboard")}</strong>
                </div>
                <div className="" style={{ marginTop: 15 }}>
                  <b className="create-ws">{t("Name your new workstream in Workboard")}</b>
                  <div className="newWsName" style={{ marginTop: '5px' }}>
                    <input
                      className="newWsNameInput"
                      type="text"
                      name="newWsName"
                      ref="ws-jql-wsName"
                      style={{ padding: '5px' }}
                      defaultValue={(this.props.items.importEditData && this.props.items.importEditData.wsName) ? this.props.items.importEditData.wsName : ''}
                      placeholder="Workstream Name"
                      onChange={this.handleWorkStreamNameChange.bind(this)}
                    />
                  </div>
                  <div id="dialog" title="Error validating JQL" style={{ display: 'none', padding: 10 }}>
                    <p style={{ padding: 10 }}>{t("There was an error processing the jql query. Please check and try again")}.</p>
                  </div>
                </div>
                <div
                  className=""
                  style={{
                    marginTop: 15, width: '95%', borderTop: '1px solid lightgrey', paddingTop: '20px',
                  }}
                >
                  <div className="sync-chkBox">
                    <input
                      type="checkbox"
                      className="css-checkbox select-option"
                      name="sync-project"
                      defaultChecked={this.props.items.syncTask ? this.props.items.syncTask : false}
                      onClick={e => this.syncTaskClicked(e, true)}
                      id="sync-project"
                    />
                    <label className="css-label modalParaText sync-project" htmlFor="sync-project" />
                  </div>
                  <div className="sync-lable">
                    <div className="sync-lable-head">{t("Sync Tasks (action items)")}</div>
                    <div className="sync-lable-sub">{t("Syncing Tasks will pull tasks from jira and convert them to action items in workboard")}</div>
                  </div>
                </div>
              </div>
              {!this.props.items.syncTask && <div className="import-from-button" style={{ display: 'block' }} onClick={e => this.saveImportBasic()}>Import</div>}
            </div>
          </div>
        );
      }
      return (
        <div>
          <div className="wsImprotComp componentMapFrom">
            <div className="wsImportCompTitle">{t("Would you like to use the guided wizard or JQL for your integration mapping")}?</div>
            <div className="comp-mapTo-wrap radio-toolbar">
              <label style={{ margin: '0px 40px' }} className="radio-button-label">
                <input
                  type="radio"
                  name="qtype"
                  value="basic"
                  checked={this.state.selectedOption == 'basic'}
                  onChange={this.handleOptionChange}
                />
                {' '}
                {t("Basic")}
              </label>
              <label style={{ margin: '20px 0' }}>
                <input
                  type="radio"
                  name="qtype"
                  value="jql"
                  checked={this.state.selectedOption == 'jql'}
                  onChange={this.handleOptionChange}
                />
                {' '}
                {t("JQL")}
              </label>
            </div>
          </div>
          {this.state.selectedOption == 'basic' && (
          <div className="wsImprotComp componentMapFrom">
            <div className="wsImportCompTitle">{t("Select which component you want to map to")}</div>
            <div className="comp-mapTo-wrap">
              <div className={`mapTo-tab story-tab ${storyActive}`} onClick={e => this.storyClick(StroyName.toLowerCase())}><p>{StroyName}</p></div>
              {importFrom != 'asana' && <div className={`mapTo-tab epic-tab ${epicActive}`} onClick={e => this.epicClick(epicName.toLowerCase())}><p>{epicName}</p></div>}
              <div className={`mapTo-tab project-tab ${projectActive}`} onClick={e => this.projectClick(projectName.toLowerCase())}><p>{projectName}</p></div>
            </div>
          </div>
          )}
          {this.state.selectedOption == 'jql' && (
          <div className="wsImprotComp componentMapFrom">
            <div className="wsImportCompTitle">{t("Work in JIRA that needs to be imported")}</div>
            <div className="comp-mapTo-wrap" style={{ width: '90%', margin: '0 auto' }}>
              <div>
                <label style={{ float: 'left', margin: '0px 10px 10px 10px' }}>
                  <ImgIconComp id="jira" style={{ verticalAlign: 'bottom' }} width="20" height="20" />
                  {' '}
                {t('Jira JQL query for all issues to be imported:')}
                </label>
                <div className="clear" />
                {this.state.showCompleteJqlError && <div style={{ color: '#FF0000', textAlign: 'left', margin: '0 20px' }} className="">{t('Please enter the jql for validation')}</div>}
                <textarea
                  onChange={this.handleTextChange.bind(this)}
                  value={this.state.jqlVal}
                  placeholder={t('Add your JQL query to pull the issues that you would like to see in Workboard. You can use any JIRA attributes to narrow down and filter the search results. \n EX. project = K2 AND Sprint = 42')}
                  ref="ws-jql-query"
                  style={{
                    width: '92%', borderRadius: '5px', 'min-height': '75px', resize: 'none', padding: '5px', display: 'inherit', margin: '0px 15px',
                  }}
                />
              </div>
            </div>
            <div className="select-project-content">
              <div className="button-wrap">
                <div
                  className="import-from-button"
                  style={{
                    display: 'table', width: '120px', height: '24px', padding: '5px',
                  }}
                  onClick={this.validateJqlQuery}
                >
                {t('Validate')}
                </div>
              </div>
            </div>
          </div>
          )}
          {/** This is the User Mapping section that will display when a valid jql is */}
          {this.state.selectedOption == 'jql' && this.state.jqlIsVerified
              && (
              <div>
                <div className="wsImprotComp componentValidateForm">
                  <div className="wsImportCompTitle">{t('Workflow Mapping to WorkBoard')}</div>
                  <div style={{
                    width: '45%', margin: 15, display: 'inline-block', 'text-align': 'left', marginTop: 10,
                  }}
                  >
                    <div>
                      <div className="project-to-icon"><ImgIconComp id="jira" width="20" height="20" /></div>
                      <strong className="project-to-lable">{t("JIRA WORKFLOW")}</strong>
                    </div>
                    <div className="" style={{ marginTop: 15 }}>
                      <div>
                        <select style={{ width: '250px' }} multiple="multiple" className="jira-workflow-select-doing" />
                      </div>
                      <br />
                      <div>
                        <select style={{ width: '250px', marginTop: '10px' }} multiple="multiple" className="jira-workflow-select-done" />
                      </div>
                      <br />
                      <div>
                        <select style={{ width: '250px', marginTop: '10px' }} multiple="multiple" className="jira-workflow-select-next" />
                      </div>
                      <br />
                      <div>
                        <select style={{ width: '250px', marginTop: '10px' }} multiple="multiple" className="jira-workflow-select-pause" />
                      </div>
                      <br />
                    </div>
                  </div>
                  <div style={{
                    width: '45%', margin: 15, display: 'inline-block', verticalAlign: 'top', textAlign: 'left', marginTop: 10,
                  }}
                  >
                    <div>
                      <div className="project-to-icon"><ImgIconComp id="workboard" width="20" height="20" /></div>
                      <strong className="project-to-lable">{t("WORKBOARD STATUS")}</strong>
                    </div>
                    <div className="" style={{ marginTop: 15 }}>
                      <p>
                        <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                        {t("DOING")}
                      </p>
                      <br />
                      <p>
                        <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                        {t("DONE")}
                      </p>
                      <br />
                      <p>
                        <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                        {t("NEXT")}
                      </p>
                      <br />
                      <p>
                        <ImgIconComp style={{ margin: '0 30px 0 -30px' }} id="mapping_arrow" width={24} />
                        {t("PAUSE")}
                      </p>
                      <br />
                    </div>
                  </div>
                </div>
                <div className="wsImprotComp componentValidateForm">
                  <div className="wsImportCompTitle">{t("Set up your WorkBoard Workstream")}</div>
                  <div style={{
                    width: '100%', padding: 15, 'text-align': 'left', marginTop: 10,
                  }}
                  >
                    <div>
                      <div className="project-to-icon"><ImgIconComp id="workboard" width="20" height="20" /></div>
                      <strong className="project-to-lable">{t("Workboard")}</strong>
                    </div>
                    <div className="" style={{ marginTop: 15 }}>
                      <b className="create-ws">{t("Name your new workstream in Workboard")}</b>
                      <div className="newWsName" style={{ marginTop: '5px' }}>
                        <input
                          className="newWsNameInput"
                          type="text"
                          name="newWsName"
                          ref="ws-jql-wsName"
                          style={{ padding: '5px' }}
                          defaultValue={(this.props.items.importEditData && this.props.items.importEditData.wsName) ? this.props.items.importEditData.wsName : ''}
                          placeholder="Workstream Name"
                          onChange={this.handleWorkStreamNameChange.bind(this)}
                        />
                      </div>
                      <div id="dialog" title="Error validating JQL" style={{ display: 'none', padding: 10 }}>
                        <p style={{ padding: 10 }}>{t("There was an error processing the jql query. Please check and try again")}.</p>
                      </div>
                    </div>
                    <div
                      className=""
                      style={{
                        marginTop: 15, width: '95%', borderTop: '1px solid lightgrey', paddingTop: '20px',
                      }}
                    >
                      <div className="sync-chkBox">
                        <input
                          type="checkbox"
                          className="css-checkbox select-option"
                          name="sync-project"
                          defaultChecked={this.props.items.syncTask ? this.props.items.syncTask : false}
                          onClick={e => this.syncTaskClicked(e)}
                          id="sync-project"
                        />
                        <label className="css-label modalParaText sync-project" htmlFor="sync-project" />
                      </div>
                      <div className="sync-lable">
                        <div className="sync-lable-head">{t("Sync Tasks (action items)")}</div>
                        <div className="sync-lable-sub">{t("Syncing Tasks will pull tasks from jira and convert them to action items in workboard")}</div>
                      </div>
                    </div>
                  </div>
                  {!this.props.items.syncTask && <div className="import-from-button" style={{ display: 'block' }} onClick={e => this.saveActionItemJql()}>Import</div>}
                </div>
              </div>
              )}
        </div>
      );
    }
    return (
      <div className="wsImprotComp componentMapFrom">
        <div className="wsImportCompTitle">{t("Select which component you want to map to")}</div>
        <div className="comp-mapTo-wrap">
          <div className={`mapTo-tab story-tab ${storyActive}`} onClick={e => this.storyClick(StroyName.toLowerCase())}><p>{StroyName}</p></div>
          {importFrom != 'asana' && <div className={`mapTo-tab epic-tab ${epicActive}`} onClick={e => this.epicClick(epicName.toLowerCase())}><p>{epicName}</p></div>}
          <div className={`mapTo-tab project-tab ${projectActive}`} onClick={e => this.projectClick(projectName.toLowerCase())}><p>{projectName}</p></div>
        </div>
      </div>
    );
  }
}

/* select Import Project block */
class SelectImportProject extends React.Component {
  constructor(props) {
    super(props);
    const importId = this.props.items.importId || 0; let
      wsName = '';
    if (importId != 0) {
      const importEditData = this.props.items.importEditData || {};
      if (importEditData.wsName) {
        wsName = importEditData.wsName;
      }
    }
    this.state = {
      wsName,
      projectId: '',
      checkbox_error: false,
      ws_name_error: false,
      syncTask: this.props.items.syncTask || false,
      syncTaskClick: false,
      projectVal: '',
    };
    this.syncWs = this.syncWs.bind(this);
    this.projectCheckboxClick = this.projectCheckboxClick.bind(this);
    this.syncTaskClicked = this.syncTaskClicked.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeBlur = this.handleChangeBlur.bind(this);
    this.getImportData = this.getImportData.bind(this);
  }

  componentDidMount() {
    // console.log('COMING TO COMPONENT DID UPDATE');
    if (typeof this.props.items.importId !== 'undefined' && this.props.items.importId != '' && this.props.items.importId != 0
    && this.props.items.importEditData && this.props.items.importEditData.importFrom == 'jira'
    && this.props.items.importEditData.projectIds.length > 0 && this.props.items.syncTask != true) {
      this.getImportData();
    }
  }

  getImportData() {
    const _this = this;
    console.log('getImportData');
    const importFrom = this.props.items.importFrom || '';
    const projectType = this.props.items.projectType || '';
    let projectId = this.props.items.projectIds || [];
    const { syncTask } = this.state;
    const projectData = this.props.items.projectData || [];
    let projectKeys = '';
    if (projectData) {
      projectKeys = projectData.filter(item => projectId.indexOf(item.project_id) != -1).map(id => id.project_key);
    }
    console.log('PROJECT KEYS', projectKeys);
    projectKeys = projectKeys.join();
    projectId = projectId.join();

    const { teamId, selectedInstance } = this.props.items;
    const repositoriesId = this.props.items.repositorieId;
    const repositoriesIds = this.props.items.repositorieIds;
    const oldPojectID = projectId;
    $.ajax({
      url: `${wbConfig.baseUrl}/integration/getImportDataDetails`,
      type: 'post',
      data: {
        app: importFrom,
        type: projectType,
        projectId,
        projectKeys,
        teamId,
        syncTask,
        repositoriesId,
        instance_url: (typeof selectedInstance !== 'undefined') ? selectedInstance.belong_to : ''
      },
    }).done((response) => {
      // console.log(response)
      removeLoader();
      if (typeof response === 'string') {
        response = response.trim();
      }
      if (response == '' || response.length == 0) {
        // console.log("response if");
      } else {
        _this.setState({
          syncTaskClick: true,
        });
        projectId = oldPojectID;
        _this.props.actions.itemToBeImport(response.data);
        let followers = [];
        followers = response.data.data.followers;
        _this.props.items.itemToBeImport.followers = followers;
      }
    });
  }

  syncWs() {
    console.log('IN SYCN TASK');
    // this.props.actions.ShowComp({compName:"ownerMapping"});
    // ReactDOM.render(<OwnerMapping  actions={this.props.actions} /> ,document.getElementById('ownerMapping'));
    // console.log($('.select-project-col-1').find('.css-checkbox:checked').length);
    const _this = this;
    if ($('.select-project-col-1').find('.css-checkbox:checked').length == 0) {
      this.setState({
        checkbox_error: true,
      });
    } else {
      this.setState({
        checkbox_error: false,
      });
    }
    if (this.state.wsName.trim() == '') {
      this.setState({
        ws_name_error: true,
      });
    } else {
      this.setState({
        ws_name_error: false,
      });
    }
    const checkboxError = this.state.checkbox_error;
    const wsNameError = this.state.ws_name_error;
    const { importFrom } = this.props.items;
    const projectType = this.props.items.projectType || '';
    const { wsName } = this.state;
    let projectId = this.props.items.projectIds || [];
    const { syncTask } = this.state;
    const projectData = this.props.items.projectData || [];
    let projectKeys = '';
    if (projectData) {
      projectKeys = projectData.filter(item => projectId.indexOf(item.project_id) != -1).map(id => id.project_key);
    }
    console.log('%o', projectKeys);
    projectKeys = projectKeys.join();
    projectId = projectId.join();

    const { teamId, selectedInstance } = this.props.items;

    if (checkboxError == false && wsNameError == false && this.state.wsName.trim() != '') {
      let repositoriesId = this.props.items.repositorieId;
      const repositoriesIds = this.props.items.repositorieIds;
      const oldPojectID = projectId;
      if (importFrom == 'github') {
        const projectIds = projectId.split(',');
        let projectIdVal = projectIds[0].split('@_repo_@');
        repositoriesId = projectIdVal[0];
        projectId = projectIdVal[1];
        const projectArray = []; const
          repositoriesIdArray = [];
        if (projectIds.length) {
          for (let i = 0; i < projectIds.length; i++) {
            projectIdVal = projectIds[i].split('@_repo_@');
            repositoriesIdArray.push(projectIdVal[0]);
            projectArray.push(projectIdVal[1]);
          }
          repositoriesId = repositoriesIdArray.join();
          projectId = projectArray.join();
        }
      }
      if (syncTask) {
        showLoaderWidget($('#content'));
        $.ajax({
          url: `${wbConfig.baseUrl}/integration/getImportDataDetails`,
          type: 'post',
          data: {
            app: importFrom, type: projectType, projectId, projectKeys, teamId, syncTask, repositoriesId,
            instance_url: (typeof selectedInstance !== 'undefined') ? selectedInstance.belong_to : ''
          },
        })
          .done((response) => {
            // console.log(response)
            removeLoader();
            if (typeof response === 'string') {
              response = response.trim();
            }
            if (response == '' || response.length == 0) {
              // console.log("response if");
            } else {
              _this.setState({
                syncTaskClick: true,
              });
              projectId = oldPojectID;
              const wsSaveData = {
                importFrom, projectType, wsName, projectId, teamId, syncTask, ownerMap: '',
              };
              _this.props.actions.saveImportData(wsSaveData);
              _this.props.actions.itemToBeImport(response.data);
              _this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'show' });
            }
          });

        // ReactDOM.render(<OwnerMapping  actions={this.props.actions} syncWs={this.props.syncWs} items={this.props.items} /> ,document.getElementById('ownerMapping'));
      } else {
        const importId = this.props.items.importId || 0;
        const selectedInstance = this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "";
        saveWsImport(importFrom, projectType, wsName, projectId, teamId, syncTask, '', repositoriesId, repositoriesIds, importId, null, null, selectedInstance);
      }
    }
  }

  projectCheckboxClick(e) {
    const _this = this;
    console.log('aaaaa', e.target.getAttribute('data-value'));
    console.log('Coming for ASANA', 'Mathe Asana');
    const importFrom = this.props.items.importFrom || '';
    const projectType = this.props.items.projectType || '';
    // console.log("projectType-->"+projectType);
    // console.log("importFrom-->"+importFrom);
    if (importFrom == 'github' && (projectType == 'label' || projectType == 'milestones')) {
      this.props.actions.saveProjectIds(e.target.value, e.target.checked, '', importFrom);
    } else {
      // this.props.actions.saveProjectIds('empty', false);
      if (importFrom == 'jira') {
        this.setState({ projectVal: e.target.getAttribute('data-value') });
        this.props.actions.saveProjectIds(e.target.getAttribute('data-value'), true, 'empty', importFrom);
        // if ((_this.props.items.itemToBeImport && _this.props.items.itemToBeImport.length < 1)
        // || typeof _this.props.items.itemToBeImport === 'undefined') {
        //   _this.getImportData();
        // }
        setTimeout(() => _this.getImportData(), 10);
        // _this.getImportData();
      } else {
        this.props.actions.saveProjectIds(e.target.value, e.target.checked, 'empty', importFrom);
      }
      console.log('projSelectedVal', this.state.projSelectedVal);
    }
    const projectIds = this.props.items.projectIds || [];
    console.log('VAL', e.target.value);
    setTimeout(() => {
      this.setState({
        checkbox_error: (projectIds.length == 0),
        projectId: projectIds.join(),
      });
    },
    10);
    const { syncTaskClick } = this.state;
    const { syncTask } = this.props.items;
    if (syncTaskClick) {
      const saveImportData = this.props.items.saveImportData || false;
      // console.log(saveImportData);
      if (saveImportData) {
        saveImportData.projectId = projectIds.join();
        this.props.actions.saveImportData(saveImportData);
        // console.log(saveImportData);
      }
    }
    console.log(`syncTask${syncTask}`);
    if (!syncTaskClick && syncTask) {
      setTimeout(() => {
        this.syncWs();
      }, 10);
    }
  }

  syncTaskClicked(e) {
    if (!e.target.checked) {
      this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
    }
    const synkcValue = e.target.checked;
    this.props.actions.saveSyncTask(synkcValue);
    setTimeout(() => {
      this.setState({
        syncTask: synkcValue,
      });
    }, 10);
    if (!e.target.checked) {
      this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
    } else {
      setTimeout(() => {
        this.syncWs();
      }, 10);
    }
  }

  handleChange(e) {
    //  console.log(e.target.value);
    this.setState({
      wsName: e.target.value,
      ws_name_error: ((e.target.value.trim() == '')),
    });
  }

  handleChangeBlur(e) {
    console.log('ON CHANGE BLUR');
    const { syncTaskClick } = this.state;
    const { syncTask } = this.props.items;
    if (syncTaskClick) {
      const saveImportData = this.props.items.saveImportData || false;
      if (saveImportData) {
        saveImportData.wsName = e.target.value;
        this.props.actions.saveImportData(saveImportData);
      }
    }
    if (!syncTaskClick && syncTask) {
      setTimeout(() => {
        this.syncWs();
      }, 10);
    }
  }

  render() {
    const { t } = this.props;
    // console.log(this.props);
    const importFrom = this.props.items.importFrom || '';
    const importFromLable = importFrom;
    const improtfromIcon = importFrom;
    const projectData = this.props.items.projectData || [];
    const projectType = this.props.items.projectType || '';

    const projectId = this.props.items.projectIds || []; // this.state.projectId

    const checkboxError = this.state.checkbox_error;
    const wsNameError = this.state.ws_name_error;
    const { wsName } = this.state;
    const { syncTask } = this.props.items;
    // console.log("projectId-->");
    // console.log(projectId);
    const errorMessage = this.props.items.repositorieError || `There is no ${projectType} in your ${improtfromIcon} account`;
    return (
      <div className="wsImprotComp select-project">
        <div className="wsImportCompTitle select-project-title">
        {t("Select which")}&nbsp;
          {projectType}
          {' '}
          {t("you want imported")}
        </div>
        <div className="select-project-content  padding-bottom15">
          <div className="wsImportCompSubTitle select-project-sub-tile">
            <div className={importFrom == 'jira' ? 'select-project-from width100' : 'select-project-from'}>
              <div className="from-icon"><ImgIconComp id={improtfromIcon} width="25" height="20" /></div>
              <div className="from-lable">{importFromLable}</div>
            </div>
            {importFrom != 'jira'
              && (
              <div className="select-project-to">
                <div className="project-to-next"><ImgIconComp id="arrow_new" width="20" height="20" /></div>
                <div className="project-to-icon"><ImgIconComp id="workboard" width="20" height="20" /></div>
                <div className="project-to-lable">{t("Workboard")}</div>
              </div>
              )
            }
          </div>

          <div className="select-project-wrap">
            <div className="select-project-col-1">
              {projectId.length < 0 && (
              <div className={`error-text ${(checkboxError) ? 'error-text-show' : ''}`}>
                {t("Please select")}
                {projectType}
              </div>
              )}
              {projectData.length > 0 && projectData.map((item) => {
                if (importFrom == 'jira') {
                  console.log('PROJECT ID', projectId);
                  return (
                    <RadioButComp
                      id={`select-project-${(importFrom == 'github') ? `${projectType}-${item.repositories_name}-` : ''}${item[`${projectType}_id`]}`}
                      label={item[`${projectType}_name`]}
                      onClick={this.projectCheckboxClick}
                      forWSImport
                      radioButProps={{
                        name: 'select-project[]',
                        defaultChecked: (importFrom == 'github') ? ((projectId.indexOf(`${item.repositories_name}@_repo_@${item[`${projectType}_id`]}`) > -1)) : ((projectId.indexOf(item[`${projectType}_id`]) > -1)),
                        value: ((importFrom == 'github') ? `${item.repositories_name}@_repo_@${item[`${projectType}_id`]}` : item[`${projectType}_id`]),
                        repo: item.repositories_name,
                      }}
                    />
                  // <input type="radio"  name="select-project[]" defaultChecked = {(importFrom =='github') ? ((projectId.indexOf(item["repositories_name"]+"@_repo_@"+item[projectType+"_id"])>-1) ? true: false) : ((projectId.indexOf(item[projectType+"_id"])>-1) ? true: false)}
                  // value={((importFrom =='github') ? item["repositories_name"]+"@_repo_@"+item[projectType+"_id"] : item[projectType+"_id"])}
                  // onClick={(e) => this.projectCheckboxClick(e)}
                  // />
                  );
                }
                return (
                  <div className="select-project-tab">
                    <input
                      type="checkbox"
                      className="css-checkbox select-option"
                      checked={(importFrom == 'github') ? (!!((projectId.length > 0 && projectId.indexOf(`${item.repositories_name}@_repo_@${item[`${projectType}_id`]}`) > -1))) : (!!((projectId.length > 0 && projectId.indexOf((item[`${projectType}_id`]).toString()) > -1)))}
                      repo={item.repositories_name}
                      key={(((importFrom == 'github') ? `${item.repositories_name}@_repo_@${item[`${projectType}_id`]}` : item[`${projectType}_id`])) + item[projectType]}
                      value={((importFrom == 'github') ? `${item.repositories_name}@_repo_@${item[`${projectType}_id`]}` : item[`${projectType}_id`])}
                      data-value={((importFrom == 'github') ? `${item.repositories_name}@_repo_@${item[`${projectType}_id`]}` : item[`${projectType}_id`])}
                      onChange={e => this.projectCheckboxClick(e)}
                      name="select-project[]"
                      id={`select-project-${(importFrom == 'github') ? `${projectType}-${item.repositories_name}-` : ''}${item[`${projectType}_id`]}`}
                    />
                    <label
                      className="css-label modalParaText select-project-chk"
                      htmlFor={`select-project-${(importFrom == 'github') ? `${projectType}-${item.repositories_name}-` : ''}${item[`${projectType}_id`]}`}
                      data-value={((importFrom == 'github') ? `${item.repositories_name}@_repo_@${item[`${projectType}_id`]}` : item[`${projectType}_id`])}
                      onChange={e => this.projectCheckboxClick(e)}
                      name="select-project[]"
                      id={`select-project-${(importFrom == 'github') ? `${projectType}-${item.repositories_name}-` : ''}${item[`${projectType}_id`]}`}
                    />
                    <div className="project-name truncateText">
                      <div className="project-name-div" title={item[`${projectType}_name`]}>{item[`${projectType}_name`]}</div>
                    </div>
                  </div>
                );
              })

              }
              {
                (projectData.length == 0) && <div>{errorMessage}</div>
              }
            </div>
            {importFrom != 'jira'
              && (
              <div className="select-project-col-2">
                <div className="create-ws">{t("Create a new workstream in Workboard")}</div>
                <div className={`error-text ${(wsNameError) ? 'error-text-show' : ''}`}>{t("Please enter workstream name")}</div>
                <div className="newWsName"><input className="newWsNameInput" value={wsName} onBlur={event => this.handleChangeBlur(event)} onChange={event => this.handleChange(event)} type="text" name="newWsName" placeholder="Workstream Name" /></div>
              </div>
              )
            }
          </div>
          {importFrom != 'jira'
            && (
            <div>
              <div className="bottom-down" />
              <div className="clear" />
            </div>
            )
          }
        </div>
        {importFrom != 'jira'
          && (
          <div className="select-project-content select-project-sync-wrap ">
            <div className="sync-chkBox">
              <input type="checkbox" checked={syncTask} className="css-checkbox select-option" name="sync-project" onClick={e => this.syncTaskClicked(e)} id="sync-project" />
              <label className="css-label modalParaText sync-project" htmlFor="sync-project" />
            </div>
            <div className="sync-lable">
              <div className="sync-lable-head">{t("Import Tasks (action items)")}</div>
              <div className="sync-lable-sub">
                {t("Importing Tasks will pull tasks from")}
                {importFromLable}
                {' '}
                {t("and convert them to action items in workboard")}
              </div>
            </div>
          </div>
          )
        }
        {importFrom != 'jira'
          && (
          <div className="select-project-content ">
            <div className="button-wrap">
              {(!syncTask) && <div className="import-from-button" onClick={e => this.syncWs()}>Import</div>}
            </div>
          </div>
          )
        }
      </div>

    );
  }
}

/**
 * Select Owner Mapping block
 */
class OwnerMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVictor: null,
      itemToBeImport: this.props.items.itemToBeImport,
    };
    this.makeAppUserList = this.makeAppUserList.bind(this);
    this.selectWbUser = this.selectWbUser.bind(this);
    this.clickVictor = this.clickVictor.bind(this);
    this.outsideClick = this.outsideClick.bind(this);
    this.saveActionItemJql = this.saveActionItemJql.bind(this);
    this.saveActionItem = this.saveActionItem.bind(this);
    this.saveActionItemBasic = this.saveActionItemBasic.bind(this);
  }

  componentDidMount() {
    const _this = this;
    window.addEventListener('click', this.outsideClick, true);
    _this.makeAppUserList();
  }

  makeAppUserList() {
    const _this = this;
    const itemToBeImport = this.props.items.itemToBeImport.followers || [];
    const importId = this.props.items.importId || 0;
    let userMappingList = [];
    if (importId != 0) {
      const importEditData = this.props.items.importEditData || {};
      if (importEditData.userMappingList) {
        userMappingList = importEditData.userMappingList;
      }
    }
    const contentdata = itemToBeImport.map((item, index) => {
      let sel_name = null; let
        sel_id = null;
      if (userMappingList.length > 0) {
        userMappingList.map((item1, index) => {
          if (item.id == item1.ext_uid) {
            sel_name = item1.ws_user_name;
            sel_id = item1.wb_user;
          }
          return item1;
        });
      }
      item.sel_name = sel_name;
      item.sel_id = sel_id;
      return item;
    });
    setTimeout(() => _this.setState({
      itemToBeImport: contentdata,
    }),
    10);
  }

  saveActionItemJqlmakeAppUserList() {
    // console.log('saveActionItemJqlmakeAppUserList called');
    const _this = this;
    const itemToBeImport = this.props.items.itemToBeImport.followers || [];
    const importId = this.props.items.importId || 0;
    let userMappingList = [];
    if (importId != 0) {
      const importEditData = this.props.items.importEditData || {};
      if (importEditData.userMappingList) {
        userMappingList = importEditData.userMappingList;
      }
    }
    const contentdata = itemToBeImport.map((item, index) => {
      let sel_name = null; let
        sel_id = null;
      if (userMappingList.length > 0) {
        userMappingList.map((item1, index) => {
          if (item.id == item1.ext_uid) {
            sel_name = item1.ws_user_name;
            sel_id = item1.wb_user;
          }
          return item1;
        });
      }
      item.sel_name = sel_name;
      item.sel_id = sel_id;
      return item;
    });
    setTimeout(() => _this.setState({
      itemToBeImport: contentdata,
    }),
    10);
  }

  selectWbUser(id, name, parant_id) {
    const _this = this;
    const itemToBeImport = this.props.items.itemToBeImport.followers || [];
    const contentdata = itemToBeImport.map((item, index) => {
      if (item.id == parant_id) {
        item.sel_name = name;
        item.sel_id = id;
      }
      return item;
    });
    setTimeout(() => _this.setState({
      showVictor: false,
      itemToBeImport: contentdata,

    }),
    10);
  }

  clickVictor(id) {
    const this_ = this;
    setTimeout(() => {
      this_.setState({
        showVictor: id,
      });
    }, 1);
  }

  outsideClick(e) {
    const _this = this;
    if (!$('.minPopupWrap').is(e.target) // if the target of the click isn't the container...
      && $('.minPopupWrap').has(e.target).length === 0) {
      _this.setState({
        showVictor: false,
      });
    }
  }

  saveActionItemJql() {
    // console.log('saveActionItemJql', this.props.items.wsName, this.props.items.importEditData);
    if ((typeof this.props.items.wsName === 'undefined' || this.props.items.wsName == '')
    && (typeof this.props.items.importEditData === 'undefined' || typeof this.props.items.importEditData.wsName === 'undefined'
      || this.props.items.importEditData.wsName == '')) {
      console.log('GOING TO IF');
      return toastr.error('Please add a Workstream name');
    }
    const ws = (this.props.items.wsName && this.props.items.wsName.length > 0) ? this.props.items.wsName : this.props.items.importEditData.wsName;
    const saveItems = this.props.items.itemToBeImport;
    // console.log(saveItems.followers);
    const statusMap = {
      done: { id: 0, values: [] },
      doing: { id: 1, values: [] },
      next: { id: 2, values: [] },
      pause: { id: 4, values: [] },
    };
    const doneArr = $('.jira-workflow-select-done').select2('data');
    doneArr.map((item, index) => {
      statusMap.done.values.push({ id: item.id, text: item.text, type: 'status' });
    });
    const doingArr = $('.jira-workflow-select-doing').select2('data');
    doingArr.map((item, index) => {
      statusMap.doing.values.push({ id: item.id, text: item.text, type: 'status' });
    });
    const nextArr = $('.jira-workflow-select-next').select2('data');
    nextArr.map((item, index) => {
      statusMap.next.values.push({ id: item.id, text: item.text, type: 'status' });
    });
    const pauseArr = $('.jira-workflow-select-pause').select2('data');
    pauseArr.map((item, index) => {
      statusMap.pause.values.push({ id: item.id, text: item.text, type: 'status' });
    });
    const ownerMap = saveItems.followers || [];
    const selectedInstance = this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "";
    saveWsImport(this.props.items.importFrom, null, ws, null, this.props.items.teamId, this.props.items.syncTask, ownerMap, null, null, this.props.items.importId, this.props.items.jql, statusMap, selectedInstance);
  }

  saveActionItemBasic() {
    console.log('saveActionItemBasic', this.props.items.wsName, this.props.items.importEditData);
    if ((typeof this.props.items.wsName === 'undefined' || this.props.items.wsName == '')
      && (typeof this.props.items.importEditData === 'undefined' || typeof this.props.items.importEditData.wsName === 'undefined'
        || this.props.items.importEditData.wsName == '')) {
      console.log('GOING TO IF');
      return toastr.error('Please add a Workstream name');
    }
    const ws = (this.props.items.wsName && this.props.items.wsName.length > 0) ? this.props.items.wsName : this.props.items.importEditData.wsName;

    const saveItems = this.props.items.itemToBeImport;
    // console.log(saveItems.followers);
    const statusMap = {
      done: { id: 0, values: [] },
      doing: { id: 1, values: [] },
      next: { id: 2, values: [] },
      pause: { id: 4, values: [] },
    };
    const doneArr = $('.jira-workflow-select-done').select2('data');
    doneArr.map((item, index) => {
      console.log('doneArr', item);
      statusMap.done.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const doingArr = $('.jira-workflow-select-doing').select2('data');
    doingArr.map((item, index) => {
      console.log('doingArr', item);
      statusMap.doing.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const nextArr = $('.jira-workflow-select-next').select2('data');
    nextArr.map((item, index) => {
      console.log('nextArr', item);
      statusMap.next.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const pauseArr = $('.jira-workflow-select-pause').select2('data');
    pauseArr.map((item, index) => {
      console.log('pauseArr', item);
      statusMap.pause.values.push({ id: item.id.split('*')[0], text: item.text, type: item.id.split('*')[1] });
    });
    const ownerMap = saveItems.followers || [];


    const { importFrom } = this.props.items;
    const projectType = this.props.items.projectType || '';
    let projectId = this.props.items.projectIds || [];
    projectId = projectId.join();

    const { teamId } = this.props.items;
    const repositoriesId = this.props.items.repositorieId;
    const repositoriesIds = this.props.items.repositorieIds;
    const oldPojectID = projectId;
    const importId = this.props.items.importId || 0;
    const selectedInstance = this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "";

    projectId = oldPojectID;
    saveWsImport(importFrom, projectType, ws, projectId, teamId, this.props.items.syncTask, ownerMap, repositoriesId, repositoriesIds, importId, '', statusMap, selectedInstance, true);
  }

  saveActionItem() {
    console.log('saveActionItem called');
    const saveItems = this.props.items.itemToBeImport;
    // console.log("save items");
    // console.log(saveItems.followers);
    const ownerMap = saveItems.followers || [];
    const { saveImportData } = this.props.items;
    // console.log("saveImportData");
    // console.log(saveImportData);
    let repositoriesId = this.props.items.repositorieId;
    const repositoriesIds = this.props.items.repositorieIds;
    let k = saveImportData.projectId;
    if (saveImportData.importFrom == 'github') {
      const projectIds = saveImportData.projectId.split(',');
      let projectIdVal = projectIds[0].split('@_repo_@');
      repositoriesId = projectIdVal[0];
      k = projectIdVal[1];
      const projectArray = []; const
        repositoriesIdArray = [];
      if (projectIds.length) {
        for (let i = 0; i < projectIds.length; i++) {
          projectIdVal = projectIds[i].split('@_repo_@');
          repositoriesIdArray.push(projectIdVal[0]);
          projectArray.push(projectIdVal[1]);
        }
        repositoriesId = repositoriesIdArray.join();
        k = projectArray.join();
      }
    }
    const importId = this.props.items.importId || 0;
    const selectedInstance = this.props.items.selectedInstance ? this.props.items.selectedInstance.belong_to : "";
    saveWsImport(saveImportData.importFrom, saveImportData.projectType, saveImportData.wsName, k, saveImportData.teamId, saveImportData.syncTask, ownerMap, repositoriesId, repositoriesIds, importId, null, null, selectedInstance);
  }

  render() {
    const { t } = this.props;
    // console.log("OwnerMapping render");
    const itemToBeImport = this.props.items.itemToBeImport.followers || [];
    const { importFrom } = this.props.items;
    const { teamUser } = this.props.items;
    const errorMessage = this.props.items.itemToBeImport.error || '';

    return (
      <div className="wsImprotComp owner-mapping">
        <div className="wsImportWrap">
          <div className="wsImportCompTitle">
            <div className="owner-mapping-title">Owner Mapping</div>
          </div>

          <div className="wsImportSubText">
            <div className="">
              {t("Specify ownership of action items to be mapped between")}
              {importFrom.toUpperCase()}
              {' '}
              {t("and Workboard")}
            </div>
          </div>

          <div className="mapping-wrap">
            {
              itemToBeImport.length > 0 && itemToBeImport.map((item, index) => (
                <div className="mapping-wrap-sub">
                  <div className="owner-maping-input-wrap"><input className="owner-mapping-input" type="text" name="mapping-user" placeholder={item.name} value={item.name} disabled="disabled" /></div>
                  <div className="mapping-next"><ImgIconComp id="arrow_new" width="20" height="20" /></div>
                  <div className="owner-maping-input-wrap">
                    <input className="owner-mapping-input-1" type="text" name="mapping-vp" placeholder={item.sel_name} onClick={e => this.clickVictor(item.id)} value={item.sel_name} />
                    <div className="minPopupWrap">
                      {this.state.showVictor == item.id && <ChangeVictor teamUser={teamUser} action={this.props.actions} selectWbUser={this.selectWbUser} sel_id={item.id} />}
                    </div>
                  </div>
                  <div className="clear" />
                </div>
              ))
            }
          </div>
          {itemToBeImport.length == 0 && (
          <div>
            {errorMessage}
            {' '}
          </div>
          )}
          <div className="clear" />
          {importFrom == 'gitHub'
            && (
            <div className="status-mapping">
              <div className="wsImportCompTitle">{t("Status Mapping")}</div>
              <div className="wsImportSubText">{t("Specify statuses to be mapped between and Github and Workboard")}</div>
              <div className="status-mapping-wrap-sub">
                <div className="mapping-wrap-sub">
                  <div className="owner-maping-input-wrap"><input className="owner-mapping-input" type="text" name="mapping-user" placeholder="github tag" /></div>
                  <div className="mapping-next"><ImgIconComp id="arrow_new" width="30" height="30" /></div>
                  <div className="owner-maping-input-wrap"><input className="owner-mapping-input" type="text" name="mapping-vp" placeholder="Backlog" /></div>
                  <div className="clear" />
                </div>
              </div>
            </div>
            )

          }
          <div className="mapping-button-wrap ">
            <div className="button-wrap">
              {(this.props.items.importFrom == 'jira' && this.props.items.isJql)
                ? <div className="importWs-button" onClick={e => this.saveActionItemJql()}>{t("Import")}</div>
                : (this.props.items.importFrom == 'jira' && this.props.items.projectIds.length > 0) ? <div className="importWs-button" onClick={e => this.saveActionItemBasic()}>{t("Import")}</div> : ''}

              {(this.props.items.importFrom != 'jira') && <div className="importWs-button" onClick={e => this.saveActionItem()}>{t("Import")}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* change victor popup */
class ChangeVictor extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    // console.log(this.props);
    const { teamUser } = this.props;
    const { wbselUser } = this.props;
    const { wbselUserId } = this.props;
    const { sel_id } = this.props;
    return (
      <div className="vectopPopupWrap">
        {
          teamUser.map((item, index) => (
            <div className="selVector clickable truncateText" userId={item.id} onClick={e => this.props.selectWbUser(item.id, `${item.name} ${item.lastName}`, sel_id)}>{`${item.name} ${item.lastName}`}</div>
          ))
        }
      </div>
    );
  }
}

class SelRepo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // repositoriesId:this.props.items.repositorieId || "",
      repositorieIds: this.props.items.repositorieIds || [],
      checkbox_error: false,
    };
    this.selRepoClick = this.selRepoClick.bind(this);
    this.repositoriesCheckboxClick = this.repositoriesCheckboxClick.bind(this);
  }

  selRepoClick() {
    if (this.state.repositorieIds.length == 0) {
      this.setState({
        checkbox_error: true,
      });
    } else {
      this.setState({
        checkbox_error: false,
      });
    }
  }

  repositoriesCheckboxClick(e) {
    this.props.actions.saveRepositoriesIds(e.target.value, e.target.checked);

    setTimeout(() => {
      if (this.props.items.repositorieIds.length > 0) {
        this.props.actions.ImportFrom({ importFrom: 'github' });
        this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'show' });
        this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
        this.props.actions.ShowComp({ compName: 'selectImportProject', action: 'hide' });
      } else {
        this.props.actions.ShowComp({ compName: 'ComponentMap', action: 'hide' });
        this.props.actions.ShowComp({ compName: 'ownerMapping', action: 'hide' });
        this.props.actions.ShowComp({ compName: 'selectImportProject', action: 'hide' });
      }
      this.setState({
        checkbox_error: (this.props.items.repositorieIds.length == 0),
      });
      $('.mapTo-tab').removeClass('active');
    },
    10);
  }

  render() {
    const { t } = this.props;
    const gitRepositoriesData = this.props.items.gitRepositoriesData || '';
    const checkboxError = this.state.checkbox_error;
    const repositorieIds = this.props.items.repositorieIds || [];
    // console.log(repositorieIds);
    // console.log("from redux"+this.props.items.repositorieIds )
    const reporError = this.props.items.repositorieError || 'There is no repositories in your git account';
    return (
      <div className="wsImprotComp selRepo">
        <div className="wsImportWrap">
          <div className="wsImportCompTitle">{t("Select which repository you want to use")}</div>
          <div className="selRepo-content" style={{ marginLeft: ((gitRepositoriesData.length == 0) ? '0px' : '235px'), width: ((gitRepositoriesData.length == 0) ? '100%' : '60%'), textAlign: ((gitRepositoriesData.length == 0) ? 'center' : 'left') }}>
            <div className={`error-text ${(checkboxError) ? 'error-text-show' : ''}`}>{t("Please select repositories")}</div>
            {gitRepositoriesData.length > 0 && gitRepositoriesData.map(item => (
              <div className="repSel-col">
                <div className="repoName-sel">
                  <input type="checkbox" className="css-checkbox select-option" checked={(repositorieIds.indexOf(item.repositories_name) > -1)} onClick={e => this.repositoriesCheckboxClick(e)} value={item.repositories_name} name="selRepo[]" id={`selRepo-${item.repositories_id}`} />
                  <label className="css-label modalParaText repoName-sel" htmlFor={`selRepo-${item.repositories_id}`} />
                </div>
                <div className="repoName  truncateText">{item.repositories_label}</div>
                <div className="clear" />
              </div>
            ))
            }
            {
              (gitRepositoriesData.length == 0) && <div>{reporError}</div>
            }


          </div>
          <div className="clear" />

        </div>
      </div>
    );
  }
}

class SelInstance extends React.Component {
  constructor(props) {
    super(props);

    const instances = this.formatInstancesForDropdown(this.props.items.instances);
    let selectedInstance;
  
    if (this.props.items.importEditData && this.props.items.importEditData.selectedInstance) {
      selectedInstance = instances.find(instance =>
        instance.belong_to === this.props.items.importEditData.selectedInstance);
      if (!selectedInstance) {
        selectedInstance = {
          belong_to: this.props.items.importEditData.selectedInstance,
          name: this.props.items.importEditData.selectedInstance,
          token_state: "invalid",
          value: instances.length
        };
        instances.push(selectedInstance);
      }
    }
    else {
      selectedInstance = instances[0];
    }

    this.state = {
      instances,
      selectedInstance,
      showPopup: false
    }
    this.props.actions.setSelectedInstance(selectedInstance);

    this.formatInstancesForDropdown = this.formatInstancesForDropdown.bind(this);
    this.handleInstanceChange = this.handleInstanceChange.bind(this);
    this.updateInstances = this.updateInstances.bind(this);
  }

  formatInstancesForDropdown(instances, value = undefined) {
    return instances.map((instance, i) => {
      return Object.assign({}, instance, { name: instance.belong_to, value: value || i })
    })
  }

  handleInstanceChange(event, item) {
    this.setState({
      selectedInstance: item
    })
    this.props.actions.setSelectedInstance(item);
  }

  updateInstances(instanceUrl) {
    const existingInstance = this.state.instances.find(inst => inst.belong_to === instanceUrl);
    let selectedInstance;
    let instances;

    if (existingInstance) {
      instances = this.state.instances;
      selectedInstance = existingInstance;
    }
    else {
      const formattedData = this.formatInstancesForDropdown(
        [{ belong_to: instanceUrl, token_state: "valid" }],
        this.state.instances.length
      );

      instances = this.state.instances.concat(formattedData);
      selectedInstance = formattedData[0];
    }

    this.setState({
      instances,
      selectedInstance
    })

    this.props.actions.setSelectedInstance(selectedInstance);
    this.props.actions.saveInstances(instances);
  }

  render() {
    const { t } = this.props;
    const openInNewTab = (url) => {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    }  

    return (
      <div className="wsImprotComp selInstance">
          <div className="JiraFirstQuestion marginTopto27">{t("Selected Jira Instance")}:</div>
          <div className="jira-dropdown-container">
            <DropdownComp
              options={this.state.instances} //Replace with props later, might need to make a new object with values and names
              defaultValue={this.state.selectedInstance ? this.state.selectedInstance.value : 0}
              onChange={this.handleInstanceChange} //Should make another api call to fetch all the other projects
              wrapperClass="add-okrs-dropdown-wrapper popup-dropdown-wrapper"
              appendId="ws-import"
            />
            <div onClick={() => this.state.instances[0]['oauth2_url']? openInNewTab(this.state.instances[0]['oauth2_url']): this.setState({ showPopup: true })}
              className="add-new-instance">+ {t("Connect to new instance")}</div>
          </div>
          {this.state.selectedInstance.token_state !== "valid" &&
            <div className="amber-text warning-error">
              <i className="icon icon-warning_14px_amber"></i>
              {t("The Jira instance associated with this workstream has been disabled and/or the token has been revoked")}.
            </div>
          }
          {this.state.showPopup && <ThemeProvider><JiraIntegrationPopup action="add"
            closePopup={() => this.setState({showPopup: false})}
            updateParentState={this.updateInstances} /></ThemeProvider>}
      </div>
    )
  }
}
export default hot(withTranslation()(WorkStreamImport));
